import { render, staticRenderFns } from "./u-link.vue?vue&type=template&id=5d780514&scoped=true&"
import script from "./u-link.vue?vue&type=script&lang=js&"
export * from "./u-link.vue?vue&type=script&lang=js&"
import style0 from "./u-link.vue?vue&type=style&index=0&id=5d780514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d780514",
  null
  
)

export default component.exports